import api from '@/common/api';
import Vue from 'vue';
/* eslint-disable */

const initialState = () => ({
  selectedCandidates: [],
  candidateInfo: {},
  pendingFiles: [],
  loading: {
    load: false,
  },
  errors: {
    load: [],
  },
});


export default {
  namespaced: true,
  state: initialState,
  getters: {
    loading: (state) => state.loading,
    selectedCandidates: (state) => state.selectedCandidates,
    getCandidateInfo: (state) => (id) => state.candidateInfo[id],
    pendingFiles: (state) => state.pendingFiles,
    isFilesSending: (state) => state.pendingFiles.some(el => el.sending),
    // sendingFile: (state) => state.pendingFiles.find(el => el.sending),
  },
  mutations: {
    startLoading(state, field) {
      state.loading[field] = true;
    },
    startLoadingId(state, { field, id }) {
      state.loading[field] = id;
    },
    endLoading(state, field) {
      state.loading[field] = false;
    },
    clearError(state) {
      state.errors = initialState().errors;
    },
    setError(state, {type, errors}) {
      state.errors[type] = errors;
    },

    setSelectedCandidates(state, items) {
      state.selectedCandidates = items;
    },
    setSelectedCandidate(state, id) {
      const ind = state.selectedCandidates.findIndex(el => el === id)
      if (ind>=0) {
        state.selectedCandidates.splice(ind, 1);
      } else {
        state.selectedCandidates.push(id)
      }
    },
    setCandidateInfo(state, candidate) {
      const info = state.candidateInfo[candidate.id]
      if (!info) {
        Vue.set(state.candidateInfo, candidate.id, {
          id: candidate.id,
          name: candidate.last_name  + ' ' + candidate.first_name,
          documents: [],
          loading: true,
          error: ''
        })
      }
    },
    setCandidateDocs(state, {id, documents, error}) {
      const info = state.candidateInfo[id]
      if (info) {
        info.documents = documents
        info.loading = false
        info.error = error
      } 
    },

    setPendingFiles(state, items) {
      state.pendingFiles = items
    },
    addPendingUserFile(state, f) {
      state.pendingFiles.push({ 
        file: f, 
        name: f.name, 
        sending: false, 
        id: f.name, 
        sended: false,
        error: false,
        fromDossier: false,
        content: ''
      })
    },
    addPendingDossierFile(state, f) {
      state.pendingFiles.push({ 
        name: f.name, 
        sending: false, 
        id: f.id, 
        sended: false,
        error: false,
        fromDossier: true,
        content: ''
      })
    },
    removePendingFile(state, ind) {
      if (ind>=0 && ind<state.pendingFiles.length)
        state.pendingFiles.splice(ind, 1)
    },
    setPendingFileInfo(state, {ind, sending, content='', sended = false, error = false}) {
      if (ind>=0 && ind<state.pendingFiles.length) {
        state.pendingFiles[ind].sending = sending
        state.pendingFiles[ind].sended = sended
        state.pendingFiles[ind].error = error
        if (content)
          state.pendingFiles[ind].content = content
      }
    },

  },
  actions: {
    async loadDossier({ commit, state, getters, rootGetters }) {
      for (const id of state.selectedCandidates) {
        try {
          const response = await api.get( `/users/candidates/${id}/dossier/`, { timeout: 0 })
          commit( 'setCandidateDocs', {id, documents: response.results}) 
        } catch (e) {
          console.log(e)
          commit( 'setCandidateDocs', {id, documents: [], error: "Ошибка при загрузке досье кандидата"}) 
        }
      }
    },

    async addFilesFromDosser({ commit, state, getters, rootGetters }, selectedDocumentIds) {
      function findDoc(id) {
        for (const info of Object.values(state.candidateInfo)) {

          const documents = info.documents
          const doc = documents.find(el => el.id === id)
          if (doc)
            return doc
        }
        return 0
      }

      for (const id of selectedDocumentIds) {
        const doc = findDoc(id)
        if (doc) 
          commit('addPendingDossierFile', doc)
        // try {
        //   const response = await api.get( `/users/candidates/${id}/dossier/`)
        //   commit( 'setCandidateDocs', {id, documents: response.results}) 
        // } catch (e) {
        //   console.log(e)
        //   commit( 'setCandidateDocs', {id, documents: [], error: "Ошибка при загрузке досье кандидата"}) 
        // }
      }
    },
  },
};
